import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import InlineBadgeEditor from "./InlineBadgeEditor";
import { getVisibilityScopeLabels, VisibilityScopes, visibilityScopeColors, VisibilityScopeValue } from "./VisibilityScope";

export type VisibilityProps = {
  value?: VisibilityScopeValue;
  onChange: (value: VisibilityScopeValue) => void;
};

const Visibility: FC<VisibilityProps> = ({ value, onChange }) => {
  const i18n = useI18n();
  const labels = getVisibilityScopeLabels(i18n);

  const options = VisibilityScopes.map((scope) => ({
    value: scope,
    label: labels[scope],
    color: visibilityScopeColors[scope],
  }));

  return <InlineBadgeEditor value={value} options={options} onChange={onChange} />;
};

export default Visibility;
